/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertSubLimitPayloadDto
 */
export interface UpsertSubLimitPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertSubLimitPayloadDto
     */
    subLimitId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertSubLimitPayloadDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertSubLimitPayloadDto
     */
    peril: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertSubLimitPayloadDto
     */
    amount: string;
}

/**
 * Check if a given object implements the UpsertSubLimitPayloadDto interface.
 */
export function instanceOfUpsertSubLimitPayloadDto(value: object): value is UpsertSubLimitPayloadDto {
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('peril' in value) || value['peril'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function UpsertSubLimitPayloadDtoFromJSON(json: any): UpsertSubLimitPayloadDto {
    return UpsertSubLimitPayloadDtoFromJSONTyped(json, false);
}

export function UpsertSubLimitPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertSubLimitPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subLimitId': json['subLimitId'] == null ? undefined : json['subLimitId'],
        'country': json['country'],
        'peril': json['peril'],
        'amount': json['amount'],
    };
}

export function UpsertSubLimitPayloadDtoToJSON(json: any): UpsertSubLimitPayloadDto {
    return UpsertSubLimitPayloadDtoToJSONTyped(json, false);
}

export function UpsertSubLimitPayloadDtoToJSONTyped(value?: UpsertSubLimitPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subLimitId': value['subLimitId'],
        'country': value['country'],
        'peril': value['peril'],
        'amount': value['amount'],
    };
}

